// extracted by mini-css-extract-plugin
export var content = "_79-3";
export var list = "_79-4";
export var settingsContent = "_79-7";
export var settingsPanel = "_79-8";
export var state = "_79-6";
export var triggerBadge = "_79-2";
export var triggerButton = "_79-1";
export var triggerShell = "_79-0";
export var unreadDot = "_79-5";